import { connect } from 'react-redux';

import { useGetPackage } from '@common/features/DynamicPackagesConfigurationWizard/useGetPackage';
import { useRate } from '@common/features/rates';
import { RateDetail } from '@routes/Rate/RateDetail';
import { basketSelectors } from '@store/basket/selectors';
import { NormalizedStore } from '@store/entity/entity.types';
import { changeJourneyParam, setJourneyParams } from '@store/yourJourney/actions';
import { yourJourneySelectors } from '@store/yourJourney/selectors';
import { parseDateToString } from '@utils/helpers';
import { useRouter } from 'shared-routing';
import { PackageDetail } from './PackageDetail';

const mapStateToProps = (state: NormalizedStore) => ({
  journeyParams: yourJourneySelectors.getParsedJourneyParams(state),
  roomIdsInBasket:
    basketSelectors.getBasketDetails(state)?.items?.map((room) => room?.bookable?.ids?.roomId) ||
    [],
});

const mapDispatchToProps = {
  changeJourneyParam,
  setJourneyParams,
};

export const RateOrPackage = (props) => {
  const router = useRouter();
  const { query } = router;
  const rateCode = query.id as string;
  const promoRateCode = typeof query.promoRateCode === 'string' ? query.promoRateCode : undefined;
  const adults = props.journeyParams.adults ?? 0;
  const children = props.journeyParams.children ?? 0;
  const childAges = props.journeyParams.childAges;
  const rooms = props.journeyParams.rooms || [{ roomNumber: 1, adults, children }];
  const fromDate = parseDateToString(props.journeyParams.fromDate);
  const toDate = parseDateToString(props.journeyParams.toDate);

  const { rate } = useRate(rateCode, {
    fromDate,
    toDate,
    adults,
    children,
    childAges,
    promoRateCode,
    rooms,
  });

  const { data: packageData } = useGetPackage({
    propertyUuid: props.property?.uuid ?? '',
    rateId: rate?.uuid ?? '',
  });
  const isPackage = !!packageData?.experiences.length || !!packageData?.restaurants?.length;

  return isPackage ? <PackageDetail {...props} /> : <RateDetail {...props} />;
};

export const RateOrPackageContainer: any = connect(
  mapStateToProps,
  mapDispatchToProps
)(RateOrPackage);
